<script setup>

import {ErrorMessage, Field} from "vee-validate"

const model = defineModel()

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: () => 'text',
    validator(value) {
      return ['text', 'email', 'number', 'password', 'textarea', 'tel', 'hidden', 'search'].includes(value)
    }
  },
  inputId: {
    type: String,
    default: () => ('id' + Math.floor(Math.random() * 100000) + 1)
  },
  name: {
    type: String,
    default: () => ('name_' + Math.floor(Math.random() * 100000) + 1)
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  help: {
    type: String,
    default: ''
  },
  pattern: {
    type: String,
    default: () => null
  }
})

</script>

<template>
  <div class="text-md italic">
    <label
      v-if="props.type !== 'hidden'"
      class="block mb-2 underline"
      :for="props.inputId"
    >
      {{ props.label }}
    </label>
    <Field
      v-if="props.type !== 'textarea'"
      :id="props.inputId"
      :name="props.name"
      :type="props.type"
      v-model="model"
      :autofocus="props.autofocus"
      :disabled="props.disabled"
      :placeholder="props.placeholder"
      :pattern="props.pattern"
      class="p-2 text-md italic bg-gray-100 w-full rounded"
    />
    <Field
      v-if="props.type === 'textarea'"
      as="textarea"
      :id="props.inputId"
      :name="props.name"
      :type="props.type"
      v-model="model"
      :autofocus="props.autofocus"
      :disabled="props.disabled"
      :placeholder="props.placeholder"
      :pattern="props.pattern"
      class="p-2 text-md italic bg-gray-100 w-full rounded"
    />
    <div v-if="props.help" class="text-xs italic mt-1">
      {{ props.help }}
    </div>
    <ErrorMessage :name="props.name" class="text-xs col-span-12 text-teal-600 text-right mt-1"/>
  </div>
</template>
